module.exports = __webpack_public_path__ + "static/media/step2.312f284b.gif";